'use client'

import type { CookiebotScriptAgentValidatorPropsType } from '@maestro/cookiebot-cookie-consent/components/cookiebot-script/cookiebot-script.types'

import { isBotUserAgent } from '@maestro/commerce-blocks/utils/client.utils'

export function CookiebotScriptAgentValidator(
  props: CookiebotScriptAgentValidatorPropsType
) {
  const { children } = props
  const isAuditMode =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('audit') === '1'

  if (isAuditMode || isBotUserAgent()) {
    return null
  }

  return children
}
